module.exports = __webpack_public_path__ + "img/H000100_fishtail.add5c885.png";